<!--
 - Author : wanghongling.
 - Date   : 2019/5/29.
 - File   : cBSShow.承包商公示
 -->

<template>
  <div class="cbs-show">
    <layer title="运营商公示" padding="10px 20px" width="418px" style="height: 475px">
      <el-carousel :interval="5000" :indicator-position="list.length>1?'outside':'none'"
          :arrow="list.length>1?'hover':'never'">
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <ul class="cbs-list" v-if="list&&list.length>0">
            <li :class="['cbs-list-item',item.length<4?'w100':'']"  v-for="(cbs, i) in item" :key="i"
                @click="showCBS(cbs, i)">
              <p class="cbs-title" :title="cbs.businessName">{{cbs.businessName}}</p>
              <p>
                <b>法　人</b><!--eslint-disable-line-->
                <span>{{cbs.legalRepresentative }}</span>
              </p>
              <p>
                <b>有效期</b>
                <span>{{cbs.expireDate}}</span>
              </p>
              <p>
                <b>状　态</b><!--eslint-disable-line-->
                <span :class="['state',cbs.status==='1'?'warn-state':'']">{{cbs.status|filterState}}</span>
              </p>
            </li>
          </ul>
        </el-carousel-item>
        <div class="no-the-data" v-if="list && list.length===0">
          <div>
            <i class="iconfont icon-suoyourenyuan dzi"></i>
            <p>暂无运营商</p>
          </div>
        </div>
      </el-carousel>
      <transition name="slide-right-fade">
        <res-Info class="cbs-pop" :resInfo="resInfo" v-show="resInfo.resShow"></res-Info>
      </transition>
    </layer>
  </div>
</template>

<script>
export default {
  name: 'cBSShow',
  data () {
    return {
      orgId: this.$store.getters.userInfo.orgId,
      list: [],
      resInfo: {
        theTitle: '',
        theState: '1',
        resShow: false,
        licenseInfo: {},
        insuranceInfo: {}
      },
      tmpIndex: null
    }
  },
  props: {
    selectOrgId: {}
  },
  watch: {
    selectOrgId: {
      handler(cur) {
        this.orgId = cur
        this.getLicenseList()
      },
      deep: true
    }
  },
  mounted() {
    this.orgId = this.$store.getters.userInfo.orgId
    this.getLicenseList()
  },
  methods: {
    /**
     * 显示承包商详情框
     * @author: whl
     * @createDate: 2019/6/4
     * @param e
     * @param index
     * @return {Object}
     */
    async showCBS (e, index) {
      await this.getLicenseInfo(e.orgId)
      await this.getBusinesslicense(e.orgId)
      await this.getInsuranceInfo(e.orgId)
      if (this.tmpIndex === index) {
        this.resInfo.resShow = !this.resInfo.resShow
      } else {
        this.resInfo.resShow = true
      }
      this.resInfo.theTitle = e.businessName
      this.resInfo.theState = e.status
      this.tmpIndex = index
    },
    /**
     * @author wanghongling
     * @areateTime 2019/06/20
     * 获取承包商公示列表
     */
    getLicenseList() {
      this.$request.pcLicenseListGet({orgId: this.orgId}).then(res => {
        console.log('获取承包商公示列表*', res)
        if (!this.$utils.isEmptyObject(res)) {
          this.list = []
          let tmpList = res
          for (var i = 0; i < tmpList.length; i += 8) {
            this.list.push(tmpList.slice(i, i + 8))
          }
        }
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * @author wanghongling
     * @createTime 2019/06/20
     * @param orgId 组织id
     * 获取许可证信息
     */
    getLicenseInfo(orgId) {
      return this.$request.pcLicenseInfoGet({orgId: orgId}).then(res => {
        console.log('获取许可信息', res)
        this.resInfo.licenseInfo = res
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * @author wanghongling
     * @createTime 2019/06/20
     * @param orgId 组织id
     * 获取责任险信息
     */
    getInsuranceInfo(orgId) {
      return this.$request.pcInsuranceListGet({orgId: orgId}).then(res => {
        console.log('获取责任险信息', res)
        this.resInfo.insuranceInfo = res
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * @Description: 获取营业执照信息
     * @author wanghongling
     * @param orgId 组织id
     * @createDate 2019/10/17
    */
    getBusinesslicense(orgId) {
      return this.$request.pcBusinesslicenseDetailGet({orgId: orgId}).then(res => {
        console.log('获取营业执照信息', res)
        this.resInfo.businesslicense = res
      }).catch(e => {
        console.error(e)
      })
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';
  .cbs-show{
    position: relative;
    padding-bottom: 20px;
    .cbs-list{
      display: flex;
      /*justify-content: space-around;*/
      align-items: center;
      font-size: 13px;
      margin: 0 -10px -20px -10px;
      flex-wrap: wrap;
      cursor: pointer;
      .w100{
        width: 100%;
      }
      &-item{
        margin-bottom: 3px;
        padding: 5px 10px 0;
        width: 50%;
        .cbs-title{
          width: 100%;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          white-space:nowrap;
        }
        p{
          color: @lightGrey;
          padding-bottom: 4px;
          b{
            width: 40px;
            display: inline-block;
          }
          span{
            color: @darkBlue;
            margin-left: 10px;
          }
          span.state{
            padding: 0 11px;
            border-radius: 3px;
            color: #fff;
            background-color: @stateGreen;
          }
          .warn-state{
            background-color: @orange !important;
          }
        }
        p:first-child{
          font-size: 15px;
          color: @lightBlue;
        }
      }
      &-item:hover{
        background-color: rgba(0,0,0,0.4);
      }
    }
    .cbs-pop{
      position: absolute;
      right: 430px;
      top: 0;
      z-index: 2;
      .detail-wrap{
        max-height: 300px !important;
      }
    }
    .el-carousel__container{
      height: 380px;
    }
    .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
    .el-carousel__indicators--outside button{
      background-color: #000;
      opacity: 1;
    }
    .el-carousel__indicator.is-active button{
      background-color: #0a8b9c;
    }
    .el-carousel__indicator--horizontal{
      padding: 6px 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/cBSShow.vue